/** Tourism subpackage messages — English */
export default {
  tourism: {
    nav: {
      home: 'Tours',
      list: 'Tour list',
      detail: 'Tour details',
      order: 'Checkout',
      selectCity: 'Select city',
    },

    common: {
      tourism: 'Tours',
      search: 'Search',
      wantToGo: 'I want to go to',
      hotRecommend: 'Popular picks',
      priceFrom: 'from',
      all: 'All',
      line: 'Tour package',
      ticket: 'Ticket',
      keyword: 'Keywords',
      noShopping: 'No shopping stops',
      supportRefundChange: 'Refunds & changes',
      refundAnytime: 'Unused anytime refund',
      play: 'Visit',
      scenicSpot: 'attractions',
      bookNow: 'Book now',
      addCart: 'Add to cart',
      addingCart: 'Adding',
      notForSale: 'Not available',
      confirm: 'Confirm',
      cancel: 'Cancel',
      edit: 'Edit',
      add: 'Add',
      done: 'Done',
      delete: 'Delete',
      none: 'None',
      navigate: 'Navigate',
      selected: 'Selected',
      yuan: 'CNY',
      male: 'Male',
      female: 'Female',
      tip: 'Notice',
      thinkAgain: 'Think again',
      required: 'Required',
    },

    share: {
      homeTitle: '0-interest travel · Pay in installments · Explore freely',
      homeDesc: 'Installments with 0 interest & 0 fees · Trusted by 40+ banks',
      productTitle: 'For you · {name} special tour',
    },

    ticketStatus: {
      available: 'Available',
      unavailable: 'Sold out',
    },

    date: {
      today: 'Today',
      tomorrow: 'Tomorrow',
      dayAfter: '+2 days',
      weekdaySun: 'Sun',
      weekdayMon: 'Mon',
      weekdayTue: 'Tue',
      weekdayWed: 'Wed',
      weekdayThu: 'Thu',
      weekdayFri: 'Fri',
      weekdaySat: 'Sat',
      monthDay: '{month}/{day}',
      moreDates: 'More dates',
    },

    list: {
      tabAll: 'All',
      tabLine: 'Packages',
      tabTicket: 'Tickets',
      sortPrice: 'Price',
      sortSales: 'Sales',
      sortRecommend: 'Recommended',
      sortListed: 'Newest',
      playPrefix: 'Visit',
      playSuffix: 'attractions',
    },

    detail: {
      relatedProducts: 'Related products',
      packageSelect: 'Select package',
      itinerary: 'Itinerary',
      package: 'Package',
      basicInfo: 'Overview',
      productNo: 'Product ID:',
      bookingNote: 'Booking notes:',
      remarkNote: 'Remarks:',
      departure: 'Departure:',
      days: 'Duration',
      refundNote: 'Refund policy',
      refundNotSupported: 'Non-refundable',
      refundSupported: 'Refundable',
      refundRuleNotice: 'Refund policy is subject to the notes above',
      bookingNotice: 'Before you book',
      meetingPoint: 'Meeting point',
      packageService: 'Package includes',
      itineraryDetail: 'Day-by-day itinerary',
      itineraryLabel: 'Day · {desc}',
      trafficLabel: 'Transport · {desc}',
      mealsLabel: 'Breakfast · {breakfast} Lunch · {lunch} Dinner · {dinner}',
      hotelLabel: 'Hotel · {desc}',
      scenicLabel: 'Sights · {desc}',
      selfPaidScenicLabel: 'Optional sights · {desc}',
      graphicDetail: 'Details',
      costIncluded: 'Included',
      costExcluded: 'Not included',
      beforePurchase: 'Before purchase',
      agreePrefix: 'I have read and agree to',
      agreeLink: 'purchase terms',
      agreeRequired: 'Please agree to the purchase terms first',
      noRefundTitle: 'Notice',
      noRefundMsg: 'This product cannot be refunded after purchase',
      noRefundConfirm: 'Book anyway',
      noRefundCartConfirm: 'Continue anyway',
      continueAddCart: 'Continue to cart',
      cartPopupTitle: 'Select and add to cart',
      addCartSuccess: 'Added to cart',
      addCartFailed: 'Unable to add to cart. Please retry.',
      loginFailed: 'Unable to open sign-in. Please retry.',
      cartProductInvalid: 'This product or rate has changed. Please select it again.',
      productOffShelf: 'Product unavailable',
    },

    selectCity: {
      searchPlaceholder: 'Search city name',
      history: 'Recent searches',
      hotDomestic: 'Popular cities in China',
      noResult: 'No results',
      cityLabel: 'City',
      searchNoResult: 'No search results',
    },

    components: {
      selectDate: {
        title: 'Select departure date',
      },
    },

    order: {
      selectedPackage: 'Selected package:',
      validTime: 'Valid period:',
      multiTicketTip: '{count}-person ticket · select {count} travelers',
      sessionSelect: 'Session',
      valueAdded: 'Add-ons',
      deliveryMethod: 'Delivery',
      physicalTicketDelivery: '(Physical ticket delivery)',
      expressDelivery: 'Express delivery, extra',
      touristInfo: 'Travelers',
      touristNeedAdd: 'Add',
      touristForVerify: 'traveler(s) for ID verification',
      touristIndex: 'Traveler {index}',
      addTouristInfo: 'Add traveler',
      touristNeedAddInfo: 'Add',
      touristInfoSuffix: 'more traveler(s)',
      pickupPoint: 'Pickup',
      returnPoint: 'Drop-off',
      selectPickupFirst: 'Select pickup point',
      selectReturnFirst: 'Select drop-off point',
      contact: 'Contact',
      contactHint: 'For booking confirmation',
      chineseName: 'Name (Chinese)',
      namePlaceholder: 'Required · as on ID',
      mobile: 'Mobile',
      mobilePlaceholder: 'Required · contact mobile',
      shippingAddress: 'Shipping address',
      detailAddress: 'Street address',
      addressPlaceholder: 'Street, building, etc.',
      moreDiscount: 'More savings',
      coupon: 'Coupons',
      couponAvailable: '{count} available',
      couponNone: 'None available',
      bankOnlyPay: 'Valid with {bank} payment only',
      designatedBank: 'designated bank',
      editTraveler: 'Edit traveler',
      addTraveler: 'Add traveler',
      name: 'Name',
      nameMatchId: 'As on ID',
      idNumber: 'ID number',
      gender: 'Gender',
      contactPhone: 'Phone',
      contactPhonePlaceholder: 'Enter phone number',
      selectedCount: '{count} selected',
      addTravelerBtn: 'Add traveler',
      selectCoupon: 'Select coupon',
      loadingCoupons: 'Loading coupons…',
      noCoupons: 'No coupons available',
      skipCoupon: 'Do not use coupon',
      couponValidUntil: 'Valid until: {time}',
      couponUnusable: 'Not available for this order',
      discountFold: ' off',
      quantitySelect: 'Quantity',
      validSameDay: 'Valid on purchase day ({date})',
      validUntil: 'Valid until {date}',
      validUntilRaw: 'Valid until {date}',
      validDateRange: 'Valid between {from} and {to} after purchase',
      childrenRequired: '[{name}] requires at least {count} child traveler(s)',
      couponFullReduce: 'Spend {min}, save {amount}',
      couponInstantReduce: 'Save {amount} CNY',
      couponFullDiscount: 'Spend {min}, {discount}% off',
      couponInstantDiscount: '{discount}% off',
      fillContactName: 'Enter contact name',
      fillContactPhone: 'Enter contact phone',
      selectPickup: 'Select pickup point',
      selectReturn: 'Select drop-off point',
      selectShippingAddress: 'Select shipping address',
      fillDetailAddress: 'Enter street address',
      selectEnoughTravelers: 'Select enough travelers',
      selectRequiredAddons: 'Select required add-ons',
      addonMustMatchTotal: 'Add-on {names} quantity must match package total',
      addonMinPurchase: 'Add-on {names} minimum quantity: {mins}',
      selectPayMethod: 'Select a payment method',
      payMethodLoading: 'Payment methods are loading, please wait',
      installmentPeriod: '{count} mo.',
      totalDiscount: 'Save ￥{amount}',
      deleteTravelerConfirm: 'Delete this traveler?',
      deleteSuccess: 'Deleted',
      fillComplete: 'Please complete all fields',
      invalidIdNumber: 'Enter a valid ID number',
      invalidMobile: 'Enter a valid mobile number',
      idVerifyFailed: 'ID verification failed',
      updateSuccess: 'Updated',
      addSuccess: 'Added',
      maxSelect: 'Up to {count} travelers',
      outOfStock: 'You can purchase up to {count} at most~',
      fetchCouponFailed: 'Failed to load coupons',
      couponSelected: 'Coupon applied · save ¥{amount}',
      selectCouponFailed: 'Failed to apply coupon',
      calcDiscountFailed: 'Failed to calculate discount',
      couponCancelled: 'Coupon removed',
      noThreshold: 'No minimum',
      couponDefault: 'Coupon',
      placePriceSuffix: ' CNY',
      valueAddedHelp: `1. * = required add-on
2. Orange items must match order quantity`,
      idCard: 'ID card',
      studentCard: 'Student ID',
      militaryCard: 'Military ID',
      passport: 'Passport',
      householdRegister: 'Household register (for children)',
      hkMacaoPass: 'HK/Macau travel permit',
      taiwanMainlandPass: 'Taiwan compatriot permit',
      taiwanPass: 'Taiwan travel permit',
      taiwanEntryPermit: 'Taiwan entry permit',
      hkResidentPass: 'HK resident mainland permit',
      policeCard: 'Police ID',
      driverLicense: 'Driver license',
      seamanCard: 'Seaman book',
      foreignerPermanentResidence: 'Foreign permanent residence',
      macaoResidentPass: 'Macao resident mainland permit',
      hkMacaoMainlandPass: 'HK/Macau resident mainland permit',
      hkMacaoTaiwanMainlandPass: 'HK/Macau/Taiwan mainland permit',
      hkMacaoTaiwanResidence: 'HK/Macau/Taiwan residence permit',
      travelDocument: 'PRC travel document',
      homeReturnPermit: 'Home return permit',
      taiwanCompatriotCard: 'Taiwan compatriot card',
      hkIdCard: 'Hong Kong ID',
    },
  },
}
